export default __webpack_public_path__ + "static/media/grafana.8a32df4371d08428ff9aece8b07115cb.svg";